<template>
  <div class="meter-transfer-form page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 0" class="van-form-without-tab">
      <van-cell-group title="基本信息">
        <van-field required v-model="form.foper" label="联系人" placeholder="请输入联系人" :rules="[{ required: true, message: '请输入联系人' }]" />
        <van-field required :rules="[{ pattern: $pattern, message: '请输入正确的手机号' }]" v-model="form.fopermobile" label="联系手机" placeholder="请输入手机号" />
        <van-field required v-model="form.fnetmark" rows="2" autosize label="详细描述" type="textarea" maxlength="500" placeholder="请输入详细描述" :rules="[{ required: true, message: '请输入详细描述'  }]" show-word-limit />
      </van-cell-group>

      <van-cell-group title="图片资料">
        <van-field required name="masterUrls" label="" :rules="[{
                        required: true,
                        message: '请上传图片资料'}]">
          <template #input>
            <van-uploader :deletable="!$route.query.readonly" :show-upload="!$route.query.readonly" multiple :max-count="3" v-model="uploaderMst" :after-read="imgAfterReadMaster" @delete="imgOnDeleteMaster" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="视频文件">
        <van-field name="uploaderMst" label="" :rules="[{
                        required: false,
                        message: $idcardmsg}]">
          <template #input>
            <van-uploader :deletable="!$route.query.readonly" :show-upload="!$route.query.readonly" multiple :max-count="1" v-model="videoMst" accept="video/*" :after-read="videoAfterReadMaster" @delete="videoOnDeleteMaster" />
          </template>
        </van-field>
      </van-cell-group>
      <div v-show="!falg">
        <van-cell-group title="处理结果">
          <van-field v-model="form.fnetstatusname" label="处理状态" placeholder="请输入处理状态" />
          <van-field v-model="form.fnetcheckmark" rows="2" autosize label="处理意见" type="textarea" maxlength="200" placeholder="" show-word-limit />
        </van-cell-group>
      </div>
      <yonghuxuzhi v-show="falg" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button v-show="falg" :disabled="!checked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

  </div>
</template>

<script>


export default {
  name: 'MeterTransferForm',

  data() {
    return {
      typecode: 214,
      active: 0,
      active1: 0,
      popShow: false,
      uploaderMst: [], // vant自带缩略图站位
      videoMst: [], // vant自带缩略图站位
      masterUrls: [], // 图片集合
      videoUrls: [], // 视频集合
      uploaderHs: [],
      uploaderOpt: [],
      hourseUrls: [],
      optUrls: [],
      message: '',
      radio: '1',
      form: {
        fsou: this.$comm.titleShow() ? 2 : 4,
        foper: "",
        fopermobile: "",
        fnetmark: "",
        attach: []
      },
      value: '',
      showPicker: false,
      isNameSame: false,
      falg: this.$route.query.busstype ? false : true,
      checked: false
    }
  },
  mounted() {
    if (!this.falg) {
      this.info()
    }
  },
  methods: {
    changeChecked(checked) {
      this.checked = checked
    },
    // 查询详情
    info() {
      this.$http.post(this.$api.serviceinfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          this.form = res.data
          let result = this.$comm.butlerAttach(res.data)
          this.uploaderMst = result.uploaderMst
          this.videoMst = result.videoMst
          this.masterUrls = result.masterUrls
          this.videoUrls = result.videoUrls
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 图片上传
    imgAfterReadMaster(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.masterUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    // 图片删除
    imgOnDeleteMaster(file, detail) {
      this.masterUrls.splice(detail.index, 1)
    },
    // 视频上传
    videoAfterReadMaster(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.videoUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    // 视频删除
    videoOnDeleteMaster(file, detail) {
      this.videoUrls.splice(detail.index, 1)
    },
    // 手机号码格式验证
    nameChange() {
      if (this.form.uname === this.form.operator) {
        this.isNameSame = true
      } else {
        this.isNameSame = false
      }
    },
    // 提交
    onSubmit() {
      this.masterUrls.forEach(img => {
        this.form.attach.push({
          typeid: "0",
          url: img
        })
      })
      this.videoUrls.forEach(video => {
        this.form.attach.push({
          typeid: "0",
          url: video
        })
      })
      console.log(this.form)
      this.$http.post(this.$api.serviceComplain, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '水管家服务',
              path: '/mine/tousujianyi'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form {
  /deep/ .van-radio-group.van-radio-group--horizontal {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);

    .van-radio--horizontal {
      margin-right: 0;
      margin-left: 4px;

      .van-radio__label {
        margin-left: 2px;
      }
    }
  }

  .form-pop {
    width: 85%;
    height: 60%;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>